export default __webpack_public_path__ + "static/media/nepalgov_color.b6e79e82.png";